import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import WhatWeOffer from "@/pages/WhatWeOffer";
import WhoWeAre from "@/pages/WhoWeAre";
import FreeQuote from "@/pages/FreeQuote";
import Booking from "@/pages/Booking";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/what-we-offer" element={<WhatWeOffer />} />
            <Route path="/who-we-are" element={<WhoWeAre />} />
            <Route path="/free-quote" element={<FreeQuote />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/admin" element={<Admin />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
